var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Вы успешно отписались от рассылки. Вы будете переадрессованы через 3 секунды")])}
var staticRenderFns = []

export { render, staticRenderFns }